import { apiDelete } from '@/api/api.ts'

export type DeleteUserResponse = {
    id: number
    deleted: boolean
}

export const apiDeleteUser = async (id: number) => {
    return await apiDelete<DeleteUserResponse>(`/protectee/${id}`)
}
